// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Manrope/Manrope-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Manrope/static/Manrope-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/Manrope/static/Manrope-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/Manrope/static/Manrope-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/Manrope/static/Manrope-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/Manrope/static/Manrope-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/fonts/Manrope/static/Manrope-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/fonts/Manrope/static/Manrope-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/fonts/ClashDisplay/ClashDisplay-Variable.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/fonts/ClashDisplay/static/ClashDisplay-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../assets/fonts/ClashDisplay/static/ClashDisplay-Extralight.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../assets/fonts/ClashDisplay/static/ClashDisplay-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../assets/fonts/ClashDisplay/static/ClashDisplay-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../assets/fonts/ClashDisplay/static/ClashDisplay-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../assets/fonts/ClashDisplay/static/ClashDisplay-Semibold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../assets/fonts/Mulish/Mulish-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../assets/fonts/Mulish/static/Mulish-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
	--PhoneInputCountryFlag-height: 19px !important;
	--PhoneInputCountrySelectArrow-color: #000 !important;
	--PhoneInputCountrySelectArrow-opacity: 0.3 !important;
	--PhoneInputCountryFlag-borderWidth: 0 !important;
	--PhoneInputCountryFlag-borderColor: transparent !important;
	--PhoneInputCountryFlag-aspectRatio: 25 / 19 !important;
	--white: #fff;
	--purple: #052E26;
	--red: #e41d1d;
}

* {
	box-sizing: border-box;
}

*:not(body) {
	/* transition: all 0.5s; */
}

input {
	outline: none;
}

/* width */
::-webkit-scrollbar {
	width: 5px !important;
}

/* Track */
::-webkit-scrollbar-track {
	background-color: #fff;
}

/* Handle */
::-webkit-scrollbar-thumb {
	background: #052E26;
	cursor: pointer;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
	/* background: var(--blue); */
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
	-webkit-transition: background-color 5000s;
	transition: background-color 5000s;
	color: #4e4e4e;
	-webkit-text-fill-color: #4e4e4e !important;
	-webkit-box-shadow: 0 0 0 1000px #ffffff00 inset !important;
	-webkit-background-clip: text !important;
	background-clip: text !important;
}

.Global_react-select-2-listbox__DS8Qx {
	width: 200px !important;
}

body {
	margin: 0 !important;
	padding: 0 !important;
	font-family: 'Manrope';
}

button {
	cursor: pointer !important;
	font-family: 'Manrope-SemiBold' !important;
}

input[type='range'] {
	/* margin-right: 15px;
	background: rgba(0, 0, 0, 0.6);
	border-radius: 5px;
	background-size: 70% 100%;
	background-repeat: no-repeat; */
	accent-color: #052E26 !important;
}

input[type='range']::-webkit-slider-thumb,
input[type='range']::-moz-range-thumb,
input[type='range']::-ms-thumb {
	/* height: 20px;
	width: 20px;
	border-radius: 50%;
	box-shadow: 0 0 2px 0 #555;
	transition: background 0.3s ease-in-out; */
}

input[type='range']::-webkit-slider-runnable-track,
input[type='range']::-moz-range-track,
input[type='range']::-ms-track {
	/* -webkit-appearance: none;
	box-shadow: none;
	border: none;
	background: transparent; */
}

/* input::-webkit-inner-spin-button,
input::-webkit-outer-spin-button {
	-webkit-appearance: none;
	-moz-appearance: none;
} */

textarea {
	outline: none;
	resize: none !important;
}

/* input[type='number'] {
	appearance: textfield;
	-moz-appearance: textfield;
} */

/* Manrope */
@font-face {
	font-family: 'Manrope';
	src: local('Manrope'),
		url(${___CSS_LOADER_URL_REPLACEMENT_0___})
			format('truetype');
}

@font-face {
	font-family: 'Manrope-Bold';
	src: local('Manrope-Bold'),
		url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
	font-family: 'Manrope-ExtraBold';
	src: local('Manrope-ExtraBold'),
		url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

@font-face {
	font-family: 'Manrope-ExtraLight';
	src: local('Manrope-ExtraLight'),
		url(${___CSS_LOADER_URL_REPLACEMENT_3___})
			format('truetype');
}

@font-face {
	font-family: 'Manrope-Light';
	src: local('Manrope-Light'),
		url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
}

@font-face {
	font-family: 'Manrope-Medium';
	src: local('Manrope-Medium'),
		url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
}

@font-face {
	font-family: 'Manrope-Regular';
	src: local('Manrope-Regular'),
		url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
}

@font-face {
	font-family: 'Manrope-SemiBold';
	src: local('Manrope-SemiBold'),
		url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
}

/* ClashDisplay */
@font-face {
	font-family: 'Clash Display';
	src: local('ClashDisplay'),
		url(${___CSS_LOADER_URL_REPLACEMENT_8___})
			format('truetype');
}

@font-face {
	font-family: 'Clash Display-Bold';
	src: local('ClashDisplay-Bold'),
		url(${___CSS_LOADER_URL_REPLACEMENT_9___})
			format('opentype');
}

@font-face {
	font-family: 'Clash Display-ExtraLight';
	src: local('ClashDisplay-ExtraLight'),
		url(${___CSS_LOADER_URL_REPLACEMENT_10___})
			format('opentype');
}

@font-face {
	font-family: 'Clash Display-Light';
	src: local('ClashDisplay-Light'),
		url(${___CSS_LOADER_URL_REPLACEMENT_11___})
			format('opentype');
}

@font-face {
	font-family: 'Clash Display-Medium';
	src: local('ClashDisplay-Medium'),
		url(${___CSS_LOADER_URL_REPLACEMENT_12___})
			format('opentype');
}

@font-face {
	font-family: 'Clash Display-Regular';
	src: local('ClashDisplay-Regular'),
		url(${___CSS_LOADER_URL_REPLACEMENT_13___})
			format('opentype');
}

@font-face {
	font-family: 'Clash Display-SemiBold';
	src: local('ClashDisplay-SemiBold'),
		url(${___CSS_LOADER_URL_REPLACEMENT_14___})
			format('opentype');
}

/* Mullish */
@font-face {
	font-family: 'Mulish';
	src: local('Mulish'),
		url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('truetype');
}

@font-face {
	font-family: 'Mulish-Regular';
	src: local('Mulish-Regular'),
		url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('truetype');
}
`, "",{"version":3,"sources":["webpack://./src/styles/Global.module.css"],"names":[],"mappings":"AAAA;CACC,+CAA+C;CAC/C,qDAAqD;CACrD,sDAAsD;CACtD,iDAAiD;CACjD,2DAA2D;CAC3D,uDAAuD;CACvD,aAAa;CACb,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,aAAa;AACd;;AAEA,UAAU;AACV;CACC,qBAAqB;AACtB;;AAEA,UAAU;AACV;CACC,sBAAsB;AACvB;;AAEA,WAAW;AACX;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA,oBAAoB;AACpB;CACC,6BAA6B;AAC9B;;AAEA;;;;CAIC,0CAAkC;CAAlC,kCAAkC;CAClC,cAAc;CACd,2CAA2C;CAC3C,2DAA2D;CAC3D,wCAAwC;CACxC,gCAAgC;AACjC;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,oBAAoB;CACpB,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,0BAA0B;CAC1B,0CAA0C;AAC3C;;AAEA;CACC;;;;gCAI+B;CAC/B,gCAAgC;AACjC;;AAEA;;;CAGC;;;;2CAI0C;AAC3C;;AAEA;;;CAGC;;;2BAG0B;AAC3B;;AAEA;;;;GAIG;;AAEH;CACC,aAAa;CACb,uBAAuB;AACxB;;AAEA;;;GAGG;;AAEH,YAAY;AACZ;CACC,sBAAsB;CACtB;;qBAEoB;AACrB;;AAEA;CACC,2BAA2B;CAC3B;4DACwE;AACzE;;AAEA;CACC,gCAAgC;CAChC;4DAC6E;AAC9E;;AAEA;CACC,iCAAiC;CACjC;;qBAEoB;AACrB;;AAEA;CACC,4BAA4B;CAC5B;4DACyE;AAC1E;;AAEA;CACC,6BAA6B;CAC7B;4DAC0E;AAC3E;;AAEA;CACC,8BAA8B;CAC9B;4DAC2E;AAC5E;;AAEA;CACC,+BAA+B;CAC/B;4DAC4E;AAC7E;;AAEA,iBAAiB;AACjB;CACC,4BAA4B;CAC5B;;qBAEoB;AACrB;;AAEA;CACC,iCAAiC;CACjC;;qBAEoB;AACrB;;AAEA;CACC,uCAAuC;CACvC;;qBAEoB;AACrB;;AAEA;CACC,kCAAkC;CAClC;;qBAEoB;AACrB;;AAEA;CACC,mCAAmC;CACnC;;qBAEoB;AACrB;;AAEA;CACC,oCAAoC;CACpC;;qBAEoB;AACrB;;AAEA;CACC,qCAAqC;CACrC;;qBAEoB;AACrB;;AAEA,YAAY;AACZ;CACC,qBAAqB;CACrB;6DAC4E;AAC7E;;AAEA;CACC,6BAA6B;CAC7B;6DACyE;AAC1E","sourcesContent":[":root {\n\t--PhoneInputCountryFlag-height: 19px !important;\n\t--PhoneInputCountrySelectArrow-color: #000 !important;\n\t--PhoneInputCountrySelectArrow-opacity: 0.3 !important;\n\t--PhoneInputCountryFlag-borderWidth: 0 !important;\n\t--PhoneInputCountryFlag-borderColor: transparent !important;\n\t--PhoneInputCountryFlag-aspectRatio: 25 / 19 !important;\n\t--white: #fff;\n\t--purple: #052E26;\n\t--red: #e41d1d;\n}\n\n* {\n\tbox-sizing: border-box;\n}\n\n*:not(body) {\n\t/* transition: all 0.5s; */\n}\n\ninput {\n\toutline: none;\n}\n\n/* width */\n::-webkit-scrollbar {\n\twidth: 5px !important;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n\tbackground-color: #fff;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n\tbackground: #052E26;\n\tcursor: pointer;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n\t/* background: var(--blue); */\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n\ttransition: background-color 5000s;\n\tcolor: #4e4e4e;\n\t-webkit-text-fill-color: #4e4e4e !important;\n\t-webkit-box-shadow: 0 0 0 1000px #ffffff00 inset !important;\n\t-webkit-background-clip: text !important;\n\tbackground-clip: text !important;\n}\n\n.react-select-2-listbox {\n\twidth: 200px !important;\n}\n\nbody {\n\tmargin: 0 !important;\n\tpadding: 0 !important;\n\tfont-family: 'Manrope';\n}\n\nbutton {\n\tcursor: pointer !important;\n\tfont-family: 'Manrope-SemiBold' !important;\n}\n\ninput[type='range'] {\n\t/* margin-right: 15px;\n\tbackground: rgba(0, 0, 0, 0.6);\n\tborder-radius: 5px;\n\tbackground-size: 70% 100%;\n\tbackground-repeat: no-repeat; */\n\taccent-color: #052E26 !important;\n}\n\ninput[type='range']::-webkit-slider-thumb,\ninput[type='range']::-moz-range-thumb,\ninput[type='range']::-ms-thumb {\n\t/* height: 20px;\n\twidth: 20px;\n\tborder-radius: 50%;\n\tbox-shadow: 0 0 2px 0 #555;\n\ttransition: background 0.3s ease-in-out; */\n}\n\ninput[type='range']::-webkit-slider-runnable-track,\ninput[type='range']::-moz-range-track,\ninput[type='range']::-ms-track {\n\t/* -webkit-appearance: none;\n\tbox-shadow: none;\n\tborder: none;\n\tbackground: transparent; */\n}\n\n/* input::-webkit-inner-spin-button,\ninput::-webkit-outer-spin-button {\n\t-webkit-appearance: none;\n\t-moz-appearance: none;\n} */\n\ntextarea {\n\toutline: none;\n\tresize: none !important;\n}\n\n/* input[type='number'] {\n\tappearance: textfield;\n\t-moz-appearance: textfield;\n} */\n\n/* Manrope */\n@font-face {\n\tfont-family: 'Manrope';\n\tsrc: local('Manrope'),\n\t\turl(../assets/fonts/Manrope/Manrope-VariableFont_wght.ttf)\n\t\t\tformat('truetype');\n}\n\n@font-face {\n\tfont-family: 'Manrope-Bold';\n\tsrc: local('Manrope-Bold'),\n\t\turl(../assets/fonts/Manrope/static/Manrope-Bold.ttf) format('truetype');\n}\n\n@font-face {\n\tfont-family: 'Manrope-ExtraBold';\n\tsrc: local('Manrope-ExtraBold'),\n\t\turl(../assets/fonts/Manrope/static/Manrope-ExtraBold.ttf) format('truetype');\n}\n\n@font-face {\n\tfont-family: 'Manrope-ExtraLight';\n\tsrc: local('Manrope-ExtraLight'),\n\t\turl(../assets/fonts/Manrope/static/Manrope-ExtraLight.ttf)\n\t\t\tformat('truetype');\n}\n\n@font-face {\n\tfont-family: 'Manrope-Light';\n\tsrc: local('Manrope-Light'),\n\t\turl(../assets/fonts/Manrope/static/Manrope-Light.ttf) format('truetype');\n}\n\n@font-face {\n\tfont-family: 'Manrope-Medium';\n\tsrc: local('Manrope-Medium'),\n\t\turl(../assets/fonts/Manrope/static/Manrope-Medium.ttf) format('truetype');\n}\n\n@font-face {\n\tfont-family: 'Manrope-Regular';\n\tsrc: local('Manrope-Regular'),\n\t\turl(../assets/fonts/Manrope/static/Manrope-Regular.ttf) format('truetype');\n}\n\n@font-face {\n\tfont-family: 'Manrope-SemiBold';\n\tsrc: local('Manrope-SemiBold'),\n\t\turl(../assets/fonts/Manrope/static/Manrope-SemiBold.ttf) format('truetype');\n}\n\n/* ClashDisplay */\n@font-face {\n\tfont-family: 'Clash Display';\n\tsrc: local('ClashDisplay'),\n\t\turl(../assets/fonts/ClashDisplay/ClashDisplay-Variable.ttf)\n\t\t\tformat('truetype');\n}\n\n@font-face {\n\tfont-family: 'Clash Display-Bold';\n\tsrc: local('ClashDisplay-Bold'),\n\t\turl(../assets/fonts/ClashDisplay/static/ClashDisplay-Bold.otf)\n\t\t\tformat('opentype');\n}\n\n@font-face {\n\tfont-family: 'Clash Display-ExtraLight';\n\tsrc: local('ClashDisplay-ExtraLight'),\n\t\turl(../assets/fonts/ClashDisplay/static/ClashDisplay-Extralight.otf)\n\t\t\tformat('opentype');\n}\n\n@font-face {\n\tfont-family: 'Clash Display-Light';\n\tsrc: local('ClashDisplay-Light'),\n\t\turl(../assets/fonts/ClashDisplay/static/ClashDisplay-Light.otf)\n\t\t\tformat('opentype');\n}\n\n@font-face {\n\tfont-family: 'Clash Display-Medium';\n\tsrc: local('ClashDisplay-Medium'),\n\t\turl(../assets/fonts/ClashDisplay/static/ClashDisplay-Medium.otf)\n\t\t\tformat('opentype');\n}\n\n@font-face {\n\tfont-family: 'Clash Display-Regular';\n\tsrc: local('ClashDisplay-Regular'),\n\t\turl(../assets/fonts/ClashDisplay/static/ClashDisplay-Regular.otf)\n\t\t\tformat('opentype');\n}\n\n@font-face {\n\tfont-family: 'Clash Display-SemiBold';\n\tsrc: local('ClashDisplay-SemiBold'),\n\t\turl(../assets/fonts/ClashDisplay/static/ClashDisplay-Semibold.otf)\n\t\t\tformat('opentype');\n}\n\n/* Mullish */\n@font-face {\n\tfont-family: 'Mulish';\n\tsrc: local('Mulish'),\n\t\turl(../assets/fonts/Mulish/Mulish-VariableFont_wght.ttf) format('truetype');\n}\n\n@font-face {\n\tfont-family: 'Mulish-Regular';\n\tsrc: local('Mulish-Regular'),\n\t\turl(../assets/fonts/Mulish/static/Mulish-Regular.ttf) format('truetype');\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"react-select-2-listbox": `Global_react-select-2-listbox__DS8Qx`
};
export default ___CSS_LOADER_EXPORT___;
